<template>
    <div>
        <span @click="onSortRequested()"
            :style="params.enableSorting == 'true' ? 'cursor: pointer' : 'cursor: default'">{{ params.title }}</span>
        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" @click="showTooltip"
            :id="params.table ? `icon-${params.title}-${params.table}` : `icon-${params.title}`" />
        <v-icon size="1em" icon="mdi-arrow-up-thin" color="var(--darkest-color)" v-if="current_sort == 1" />
        <v-icon size="1em" icon="mdi-arrow-down-thin" color="var(--darkest-color)" v-if="current_sort == 2" />
    </div>
</template>

<script setup lang="js">
import { ref, onMounted, onUnmounted, } from 'vue';
import useTooltip from '@/methods/tooltip.js';

/**
 * @prop params - Contains the title and optionally tooltip id, colid, table_id
 */
const props = defineProps({
    params: Object,
})

/**
 * On mounting the header component, an event listener for a sorting event is added
 * This sets the sort to "none" (0) if the sort-event was not meant for this specific header.
 */
onMounted(() => {
    window.addEventListener("sort-grid", (e) => validateHeader(e));
})

/**
 * Removes the event listener if the header component is unmounted.
 */
onUnmounted(() => {
    window.removeEventListener("sort-grid", (e) => validateHeader(e));
})

/**
 * Sets the current sort to none if a sort event for a different column is caught.
 */
const validateHeader = (e) => {
    if (e.detail.table != props?.params.table) return;
    if (e.detail.column != (props?.params.colid ? props?.params.colid : props?.params.title)) current_sort.value = 0;
}

/**
 * @emit sort - Passes up a sorting request to the table
 */
const emit = defineEmits(['sort'])

/**
 * Shows the tooltip based on this header's position and variables (taken from props.params)
 */
const showTooltip = () => {
    let element_id = props?.params.table ? `icon-${props?.params.title}-${props?.params.table}` : `icon-${props?.params.title}`;
    let tooltip_id = props?.params?.tooltip_id ? props?.params?.tooltip_id : undefined;
    let tooltip_title = props?.params?.title;
    useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
}

/**
 * Fires a sort event if the user clicks this header.
 */
const onSortRequested = () => {
    if (props?.params.enableSorting != "true") return;
    //alert("sort request " + props?.params.title + ":"+event)
    var sort_event = new CustomEvent("sort-grid",
        {
            detail: {
                column: props?.params.colid ? props?.params.colid : props?.params.title,
                order: available_sorts[current_sort.value + 1 === available_sorts.length ? 0 : current_sort.value + 1],
                table: props?.params.table,
            }
        });
    if (current_sort.value + 1 == available_sorts.length) current_sort.value = 0;
    else { current_sort.value++; }
    window.dispatchEvent(sort_event);
}

const available_sorts = ['none', 'asc', 'desc'];
const current_sort = ref(0);
</script>


